import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { Box } from 'components/Box';
import { NamePlate } from 'components/NamePlate';

function Rewards({ job, application, t }) {
  return (
    <Stack space={6}>
      <Stack space={4}>
        <Text font="heading2" text={`${t('application.onboarding.rewards.header')} 🎉`} />
        {job.hasRewards && (
          <Text>
            <strong>{job.rewardsTitle}</strong>
            <Text>{job.rewards}</Text>
          </Text>
        )}
      </Stack>

      {!job.hasRewards && <Text text={t('application.onboarding.rewards.norewards')} />}

      <Stack space={2}>
        <Text font="bold14" text={t('application.onboarding.rewards.sourcedby')} />

        {application.referredBy && (
          <Box mt="8">
            <RewardsCard>
              <NamePlate
                name={application.referredBy.name}
                size="lg"
                pic={application.referredBy.picture}
                title={application.referredBy.roleDisplay}
              />
            </RewardsCard>
          </Box>
        )}
        {!application.referredBy && (
          <Text color="purple60">{t('application.onboarding.rewards.nosource')}</Text>
        )}
      </Stack>
    </Stack>
  );
}

export default observer(Rewards);

const RewardsCard = styled.div((p) => ({
  backgroundColor: p.theme.colors.white100,
  borderRadius: '0.25rem',
  padding: '0.5rem 0.75rem',
  display: 'flex',
  alignItems: 'center',
}));
